var _path, _path2, _path3, _path4, _path5, _rect, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoorPatientExperience(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 130,
    viewBox: "0 0 151 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2188 66.4316C20.7412 66.4319 25.2185 70.9082 25.2188 76.4307V94.4043C25.2188 95.5089 24.3223 96.4043 23.2178 96.4043H21.3613V77.8604H20.3613V125.653C20.3611 127.537 18.8337 129.064 16.9502 129.064C15.0667 129.064 13.5403 127.537 13.54 125.653V103.226H11.6787V125.653C11.6784 127.537 10.1518 129.064 8.26855 129.064C6.38507 129.064 4.85769 127.537 4.85742 125.653V77.8604H3.85742V96.4043H2C0.895431 96.4043 4.03492e-08 95.5089 0 94.4043V76.4307C0.000263843 70.908 4.47732 66.4316 10 66.4316H15.2188ZM12.6094 47C16.9759 47.0003 20.5156 50.5406 20.5156 54.9072C20.5156 59.2738 16.9759 62.8142 12.6094 62.8145C8.2426 62.8145 4.70215 59.274 4.70215 54.9072C4.70215 50.5405 8.2426 47 12.6094 47Z",
    fill: "url(#paint0_linear_60176_428)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4375 66.4302C51.96 66.4304 56.4372 70.9077 56.4375 76.4302V94.4038C56.4375 95.5084 55.5411 96.4038 54.4365 96.4038H52.5801V77.8599H51.5801V125.653C51.5798 127.536 50.0524 129.064 48.1689 129.064C46.2855 129.064 44.7591 127.536 44.7588 125.653V103.225H42.8975V125.653C42.8972 127.536 41.3706 129.064 39.4873 129.064C37.6038 129.064 36.0764 127.536 36.0762 125.653V77.8599H35.0762V96.4038H33.2188C32.1142 96.4038 31.2188 95.5084 31.2188 94.4038V76.4302C31.219 70.9076 35.6961 66.4302 41.2188 66.4302H46.4375ZM43.8281 47.0005C48.1947 47.0008 51.7344 50.5401 51.7344 54.9067C51.7344 59.2733 48.1947 62.8137 43.8281 62.814C39.4614 62.814 35.9209 59.2735 35.9209 54.9067C35.9209 50.54 39.4614 47.0005 43.8281 47.0005Z",
    fill: "url(#paint1_linear_60176_428)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6562 66.4316C83.1787 66.4319 87.656 70.9082 87.6562 76.4307V94.4043C87.6562 95.5089 86.7598 96.4043 85.6553 96.4043H83.7988V77.8604H82.7988V125.653C82.7986 127.537 81.2712 129.064 79.3877 129.064C77.5042 129.064 75.9778 127.537 75.9775 125.653V103.226H74.1162V125.653C74.1159 127.537 72.5893 129.064 70.7061 129.064C68.8226 129.064 67.2952 127.537 67.2949 125.653V77.8604H66.2949V96.4043H64.4375C63.3329 96.4043 62.4375 95.5089 62.4375 94.4043V76.4307C62.4378 70.908 66.9148 66.4316 72.4375 66.4316H77.6562ZM75.0469 47C79.4134 47.0003 82.9531 50.5406 82.9531 54.9072C82.9531 59.2738 79.4134 62.8142 75.0469 62.8145C70.6801 62.8145 67.1396 59.274 67.1396 54.9072C67.1396 50.5405 70.6801 47 75.0469 47Z",
    fill: "url(#paint2_linear_60176_428)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M108.875 66.4302C114.397 66.4304 118.875 70.9077 118.875 76.4302V94.4038C118.875 95.5084 117.979 96.4038 116.874 96.4038H115.018V77.8599H114.018V125.653C114.017 127.536 112.49 129.064 110.606 129.064C108.723 129.064 107.197 127.536 107.196 125.653V103.225H105.335V125.653C105.335 127.536 103.808 129.064 101.925 129.064C100.041 129.064 98.5139 127.536 98.5137 125.653V77.8599H97.5137V96.4038H95.6562C94.5517 96.4038 93.6563 95.5084 93.6562 94.4038V76.4302C93.6565 70.9076 98.1336 66.4302 103.656 66.4302H108.875ZM106.266 47.0005C110.632 47.0008 114.172 50.5401 114.172 54.9067C114.172 59.2733 110.632 62.8137 106.266 62.814C101.899 62.814 98.3584 59.2735 98.3584 54.9067C98.3584 50.54 101.899 47.0005 106.266 47.0005Z",
    fill: "url(#paint3_linear_60176_428)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M140.094 66.4316C145.616 66.4319 150.093 70.9082 150.094 76.4307V94.4043C150.094 95.5089 149.197 96.4043 148.093 96.4043H146.236V77.8604H145.236V125.653C145.236 127.537 143.709 129.064 141.825 129.064C139.942 129.064 138.415 127.537 138.415 125.653V103.226H136.554V125.653C136.553 127.537 135.027 129.064 133.144 129.064C131.26 129.064 129.733 127.537 129.732 125.653V77.8604H128.732V96.4043H126.875C125.77 96.4043 124.875 95.5089 124.875 94.4043V76.4307C124.875 70.908 129.352 66.4316 134.875 66.4316H140.094ZM137.484 47C141.851 47.0003 145.391 50.5406 145.391 54.9072C145.391 59.2738 141.851 62.8142 137.484 62.8145C133.118 62.8145 129.577 59.274 129.577 54.9072C129.577 50.5405 133.118 47 137.484 47Z",
    fill: "url(#paint4_linear_60176_428)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 88.1895,
    y: 1,
    width: 37.1294,
    height: 37.1294,
    rx: 18.5647,
    stroke: "#B9C0D1",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M105.189 8V20.1011L112.851 24.5247",
    stroke: "#DCDCDC",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_60176_428",
    x1: 12.6094,
    y1: 66.4299,
    x2: 12.6094,
    y2: 129.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEE2E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C9D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_60176_428",
    x1: 43.8281,
    y1: 66.4302,
    x2: 43.8281,
    y2: 129.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEE2E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C9D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_60176_428",
    x1: 75.0469,
    y1: 66.4299,
    x2: 75.0469,
    y2: 129.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEE2E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C9D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_60176_428",
    x1: 106.266,
    y1: 66.4302,
    x2: 106.266,
    y2: 129.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8867D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D91305"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_60176_428",
    x1: 137.484,
    y1: 66.4299,
    x2: 137.484,
    y2: 129.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8867D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D91305"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoorPatientExperience);
export default __webpack_public_path__ + "static/media/poor-patient-experience.37d8b9e40f4ed7e388784d915d9d0f45.svg";
export { ForwardRef as ReactComponent };